import AddLicensesBanner from './AddLicensesBanner.connect'

export default AddLicensesBanner
